import { useTranslation } from '../../i18n/LanguageContext'
import './LangSwitcher.css'

export default function LangSwitcher() {
  const { lang, setLanguage } = useTranslation()
  const isEN = lang === 'en'

  return (
    <div className="lang-switcher">
      <button
        className={`lang-switcher__option ${isEN ? 'lang-switcher__option--active' : ''}`}
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
      <button
        className={`lang-switcher__option ${!isEN ? 'lang-switcher__option--active' : ''}`}
        onClick={() => setLanguage('pt-BR')}
      >
        PT
      </button>
    </div>
  )
}
